import React, { useState } from 'react';
import '../../DevelopmentForm/DevelopmentForm.css';
import LogoTT from '../../../Media/Logos/Logo-TT.png';

function FormSupport(){

    const[isChecked, setIsChecked] = useState(false);

    return(
        <React.Fragment>
            <div className="container-form-logo">

                <img src={LogoTT} alt="logo T&T" className="logo" />

            </div>

            <div className="title">Project Support</div>

            <form className="flip-card__form" action="">

                <ul className='list-inputs'>
                    
                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Dominio del proyecto existente</label>
                        <input 
                            className="flip-card__input" 
                            name="domain" 
                            placeholder="Domain" 
                            type="text" 
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Descripción del requerimiento</label>
                        <textarea
                            id="description-requirement"
                            className="flip-card__textarea"
                            name="description-requirement"
                            placeholder="Escribe aquí..."
                            rows="4"
                            cols="50"
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Fecha de solicitud</label>
                        <input 
                            className="flip-card__input" 
                            name="date_application" 
                            placeholder="Fecha" 
                            type="date" 
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Fecha de entrega</label>
                        <input 
                            className="flip-card__input" 
                            name="deadline" 
                            placeholder="Fecha" 
                            type="date" 
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>URL de contenido mp4, mp3</label>
                        <input 
                            className="flip-card__input" 
                            name="delivery-date-customer" 
                            placeholder="Fecha" 
                            type="text" 
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Diseño del sitio web aprobado (PDF)</label>
                        <input
                            id="designFile"
                            className="flip-card__input" 
                            name="designFile" 
                            type="file" 
                            accept='.pdf' 
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Contenido Multimedia</label>
                        <input
                            id="multimedia-file"
                            className="flip-card__input" 
                            name="multimedia-file" 
                            type="file"
                        />
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>Involucrados</label>
                        <select
                            id="involucrados"
                            className="flip-card__input"
                            name="involucrados"
                        >

                            <option value="diego">Diego Jaramillo</option>
                            <option value="edwin">Edwin Gonzalez</option>
                            <option value="sergio">Sergio Cobos</option>
                            <option value="gina">Gina Ayala</option>
                            <option value="cristian">Cristian Cobos</option>

                        </select>
                    </li>

                    <li className='list-inputs--input'>
                        <label className='list-inputs--input--label'>
                            Adicionales
                            <input 
                                type='checkbox'
                                checked={isChecked}
                                onChange={(e) => setIsChecked(e.target.checked)}
                            />
                        </label>
                    </li>

                    {isChecked &&(
                        <React.Fragment>
                            <li className='list-inputs--input'>
                                <label className='list-inputs--input--label'>Fecha de capacitación</label>
                                <input 
                                    className="flip-card__input" 
                                    name="capacition-date" 
                                    placeholder="Fecha" 
                                    type="date" 
                                />
                            </li>

                            <li className='list-inputs--input'>
                                <label className='list-inputs--input--label'>Fecha de entrega manuales (opcional)</label>
                                <input 
                                    className="flip-card__input" 
                                    name="manual-date" 
                                    placeholder="Fecha" 
                                    type="date" 
                                />
                            </li>
                        </React.Fragment>
                    )}

                </ul>

                <button className="flip-card__btn">Confirm!</button>

            </form>
            
        </React.Fragment>
    );
}

export { FormSupport };